var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3076 0.973912C28.6865 4.86336 22.4783 14.7366 23.2263 26.4049C24.6474 48.0961 52.0231 57.0717 66.3842 40.6163C70.7224 35.6797 72.0687 31.8651 72.0687 24.2358C72.0687 18.3268 71.7696 17.0553 69.9744 13.5398C67.3565 8.52841 63.2427 4.41458 58.5305 2.09587C54.0427 -0.0732467 43.8703 -0.74642 39.3076 0.973912ZM52.9955 8.15443C58.4557 9.65037 63.3923 15.4845 64.589 21.8423C66.3842 31.3415 57.7825 41.2895 47.7597 41.2895C38.8589 41.2895 32.0523 35.3058 30.7808 26.4797C29.1352 14.4374 40.8036 4.78856 52.9955 8.15443Z",
    fill: "#E5E516"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5532 54.9026C13.428 57.3709 5.4995 63.2799 2.43282 69.862C0.78729 73.2279 0.637695 74.649 0.637695 84.597V95.667H10.2117L10.5109 84.971C10.7353 74.649 10.8101 74.1254 12.8296 71.0588C15.2231 67.3937 20.3841 63.953 25.6199 62.3823C30.9305 60.8116 66.0851 60.8116 71.3957 62.3823C76.6315 63.953 81.7925 67.3937 84.186 71.0588C86.2055 74.1254 86.2803 74.649 86.5047 84.971L86.8039 95.667H96.3779V84.597C96.3779 74.649 96.2283 73.2279 94.5828 69.862C91.4413 63.1303 83.5128 57.2961 74.1632 54.9026C68.1794 53.3319 28.3126 53.4067 22.5532 54.9026Z",
    fill: "#E5E516"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg05);
export default __webpack_public_path__ + "static/media/05.0ad135b7a44575f06682413f20698c00.svg";
export { ForwardRef as ReactComponent };